import AdminIt from "pages/LandingPages/AdminIt";

export default function AdminItPage() {
  return <AdminIt />;
}
